"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _constants = require("./constants");

var _properties = require("./properties");

var _errors = require("./errors");

var _utils = require("./utils");

var _validate = require("./validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var testMintelDestination = function testMintelDestination(url) {
  return Object.keys(_constants.PRODUCT_MAP).some(function (product) {
    return (0, _includes.default)(url, product);
  });
};

var track = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event_name, properties) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              _utils.mixpanelWrapper.track(event_name, properties, {}, resolve);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function track(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var navigate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(properties) {
    var validProperties;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            validProperties = (0, _validate.validateProperties)(_constants.EVENT_TYPES.Navigate, properties, _constants.EVENT_TYPES.Navigate); // Note: navigate doesn't triger a session start, since by definition you're leaving the product

            _context2.next = 3;
            return track(_constants.EVENT_TYPES.Navigate, Object.assign({
              'Event Type': _constants.EVENT_TYPES.Navigate,
              'Mintel Destination': testMintelDestination(properties.url)
            }, validProperties));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function navigate(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = {
  navigate: navigate,
  validateProperties: function validateProperties(location, properties, eventName) {
    return (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES[eventName]);
  },
  setPeopleProperties: function setPeopleProperties() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _utils.mixpanelWrapper.people.set(Object.assign({}, properties));

    _utils.mixpanelWrapper.identify(_mixpanelBrowser.default.get_distinct_id());
  },
  identify: function identify(id) {
    _utils.mixpanelWrapper.identify(id);
  },
  alias: function alias(oldId, newId) {
    _utils.mixpanelWrapper.alias(oldId, newId);
  },
  view: function () {
    var _view = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.View);
              _context3.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _context3.next = 5;
              return track("".concat(_constants.EVENT_TYPES.View, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.View,
                'Event Subtype': location
              }, validProperties));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function view(_x4, _x5) {
      return _view.apply(this, arguments);
    }

    return view;
  }(),
  engage: function () {
    var _engage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Engage);
              _context4.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _context4.next = 5;
              return track("".concat(_constants.EVENT_TYPES.Engage, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Engage,
                'Event Subtype': location
              }, validProperties));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function engage(_x6, _x7) {
      return _engage.apply(this, arguments);
    }

    return engage;
  }(),
  manage: function () {
    var _manage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Manage);
              _context5.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _context5.next = 5;
              return track("".concat(_constants.EVENT_TYPES.Manage, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Manage,
                'Event Subtype': location
              }, validProperties));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function manage(_x8, _x9) {
      return _manage.apply(this, arguments);
    }

    return manage;
  }(),
  registrationInProgress: function () {
    var _registrationInProgress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Registration);
              _context6.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _context6.next = 5;
              return track("".concat(_constants.EVENT_TYPES.Registration, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Registration,
                'Event Subtype': location
              }, validProperties));

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function registrationInProgress(_x10, _x11) {
      return _registrationInProgress.apply(this, arguments);
    }

    return registrationInProgress;
  }(),
  download: function () {
    var _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Download);
              _context7.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _utils.mixpanelWrapper.people.increment('Number of Downloads');

              _context7.next = 6;
              return track("".concat(_constants.EVENT_TYPES.Download, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Download,
                'Event Subtype': location
              }, validProperties));

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function download(_x12, _x13) {
      return _download.apply(this, arguments);
    }

    return download;
  }(),
  search: function () {
    var _search = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Search);
              _context8.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              _utils.mixpanelWrapper.people.increment('Number of Searches');

              _context8.next = 6;
              return track("".concat(_constants.EVENT_TYPES.Search, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Search,
                'Event Subtype': location
              }, validProperties));

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function search(_x14, _x15) {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  video: function () {
    var _video = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(location, properties) {
      var validProperties;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              validProperties = (0, _validate.validateProperties)(location, properties, _constants.EVENT_TYPES.Video);
              _context9.next = 3;
              return (0, _utils.sessionStart)();

            case 3:
              track("".concat(_constants.EVENT_TYPES.Video, " - ").concat(location), Object.assign({
                'Event Type': _constants.EVENT_TYPES.Video,
                'Event Subtype': location
              }, validProperties));

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function video(_x16, _x17) {
      return _video.apply(this, arguments);
    }

    return video;
  }(),
  bindLinkToEvent: function bindLinkToEvent() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _validate.checkReservedProperties)(properties);

    if (document.querySelector(selector)) {
      _utils.mixpanelWrapper.track_links(selector, _constants.EVENT_TYPES.Navigate, Object.assign({
        'Event Type': _constants.EVENT_TYPES.Navigate,
        'Mintel Destination': testMintelDestination(document.querySelector(selector).href)
      }, properties));
    } else {
      throw new _errors.LinkNotFoundError(selector);
    }
  },
  timeEvent: function timeEvent(eventType, secondaryType) {
    if (!(0, _includes.default)(Object.keys(_constants.EVENT_TYPES), eventType)) {
      throw new _errors.UnrecognizedTypeError(eventType, _constants.EVENT_TYPES);
    }

    if (eventType !== _constants.EVENT_TYPES.Navigate && (0, _includes.default)(Object.keys(_properties.REQUIRED_PROPERTIES[eventType]), secondaryType)) {
      _utils.mixpanelWrapper.time_event("".concat(eventType, " - ").concat(secondaryType));
    } else {
      throw new _errors.UnrecognizedTypeError(secondaryType, Object.keys(_properties.REQUIRED_PROPERTIES[eventType]));
    }
  },
  increment: function increment(property) {
    if (!(0, _includes.default)(_constants.INCREMENTABLE_PROPERTIES, property)) {
      throw new _errors.UnrecognizedTypeError(property, _constants.INCREMENTABLE_PROPERTIES);
    }

    _utils.mixpanelWrapper.people.increment(property);
  },
  listenToAnchorClicks: function listenToAnchorClicks(sourceSite) {
    window.$('html').on('click', 'a', function (event) {
      var product = (0, _utils.getCurrentProduct)(undefined, event.currentTarget.href);

      if (product && product !== sourceSite) {
        navigate({
          Action: 'Exit to Other Mintel Website',
          'Destination Product Name': product,
          'Source Product Name': sourceSite,
          url: event.currentTarget.href
        });
      }
    });
  }
};
exports.default = _default;